/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import {
  FinancialIndexes,
  MasterZoneRestService,
  OfficeRestService,
  ReportSettingsRestService,
} from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { loadTinymce } from '@gh/core-ui';
import { includesIgnoreCase } from '@gh/core-util';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import {
  ReportFyaDetails,
  reportFyaDetailsFromDto,
  reportFyaDetailsToSaveDto,
  ReportFyaOffice,
} from './report-fya-details.model';

@Injectable()
export class ReportFyaDetailsBusinessService implements InitViewService {
  constructor(private userContext: BuilderUserContext,
              private dictionaries: DictionaryService,
              private masterZoneRest: MasterZoneRestService,
              private officeRest: OfficeRestService,
              private reportFyaRest: ReportSettingsRestService) {
  }

  initView(): any {
    return {
      financialIndexDict: this.dictionaries.getByEnum(FinancialIndexes),
      masterZones: this.userContext.corporateView ? this.masterZoneRest.findAll() : [this.userContext.masterZone],
      details: this.get(),
      tinymce: loadTinymce(),
    };
  }

  get(): Observable<ReportFyaDetails> {
    return this.reportFyaRest.getReporFya().pipe(map$(reportFyaDetailsFromDto));
  }

  save(details: ReportFyaDetails): Observable<ReportFyaDetails> {
    return this.reportFyaRest.updateReporFya(reportFyaDetailsToSaveDto(details)).pipe(map$(reportFyaDetailsFromDto));
  }

  findAllOfficesByMasterZone(masterZoneId: ID, filter: string): Observable<ReportFyaOffice[]> {
    return this.officeRest.findAllByMasterZone(masterZoneId).pipe(
      map$((offices) => offices.filter(({ name }) => includesIgnoreCase(name, filter))));
  }
}
